import { Store } from '../../helpers/types';
import { createSelector } from 'reselect';

export const navigationReducerSelector = (state: Store) => state.navigationState;

export const getNavigationState = createSelector(
    navigationReducerSelector,
    (navigationState) => navigationState
);
